<script>
	export let classes;
	import { fly, fade } from 'svelte/transition';
</script>

<svg
	version="1.1"
	id="illustration"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	x="0px"
	y="0px"
	viewBox="0 0 731 900"
	style="enable-background:new 0 0 731 900;"
	xml:space="preserve"
	class={classes}>
	<style type="text/css">
		.st0 {
			opacity: 7e-2;
			fill: url(#SVGID_1_);
			enable-background: new;
		}
		.st1 {
			opacity: 7e-2;
			fill: url(#SVGID_2_);
			enable-background: new;
		}
		.st2 {
			opacity: 0.4;
			fill: url(#SVGID_3_);
			enable-background: new;
		}
		.st3 {
			opacity: 0.4;
			fill: url(#SVGID_4_);
			enable-background: new;
		}
		.st4 {
			opacity: 0.15;
			fill: url(#SVGID_5_);
			enable-background: new;
		}
		.st5 {
			fill: #eac543;
		}
		.st6 {
			opacity: 0.15;
			fill: #ffffff;
			enable-background: new;
		}
		.st7 {
			opacity: 0.2;
			fill: url(#SVGID_6_);
			enable-background: new;
		}
		.st8 {
			opacity: 0.2;
			fill: #ffffff;
			enable-background: new;
		}
		.st9 {
			opacity: 0.15;
			fill: url(#SVGID_7_);
			enable-background: new;
		}
		.st10 {
			fill: #f2994a;
		}
		.st11 {
			opacity: 0.2;
			fill: url(#SVGID_8_);
			enable-background: new;
		}
		.st12 {
			opacity: 0.3;
			fill: url(#SVGID_9_);
			enable-background: new;
		}
		.st13 {
			fill: #f2c94c;
		}
		.st14 {
			opacity: 0.2;
			fill: url(#SVGID_10_);
			enable-background: new;
		}
	</style>
	<linearGradient
		id="SVGID_1_"
		gradientUnits="userSpaceOnUse"
		x1="793.3884"
		y1="-34.8961"
		x2="546.7093"
		y2="392.636"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path
		in:fade={{ delay: 1500, duration: 1000 }}
		class="st0"
		d="M730.5,452.5c-12.7-7.4-21.9-7.6-27.6-0.6c-5.7,6.9-8.5,18.6-8.5,35.1v88.9c0,16.9-1.6,30.9-4.7,42
	c-3.1,11.5-8.4,19.7-15.7,24.5c-7.1,4.9-16.7,6.2-28.9,3.9c-11.9-2.2-26.8-8.4-44.6-18.7l-8.5-4.9v-70l10.6,6.1
	c12.7,7.4,21.2,8.3,25.5,2.9c4.5-5.2,6.8-16.1,6.8-32.6v-78.3c0-20.4,2-36.5,6-48.4s11.9-19.4,23.8-22.8
	c-11.9-17.1-19.8-33.8-23.8-50.2c-4-16.4-5.9-34.8-5.9-55.2v-78.3c0-16.5-2.3-29.9-6.8-40.4c-4.2-10.3-12.7-19.1-25.5-26.5
	l-10.6-6.1v-70l8.5,4.9c17.8,10.3,32.7,21.2,44.6,32.8c12.2,11.7,21.8,24.2,28.9,37.3c7.4,13.3,12.6,27.5,15.7,42.6
	c3.1,14.7,4.7,30.6,4.7,47.4v88.9c0,16.5,2.8,31.5,8.5,44.9c5.7,13.5,14.9,23.9,27.6,31.2L730.5,452.5z" />
	<linearGradient
		id="SVGID_2_"
		gradientUnits="userSpaceOnUse"
		x1="674.8008"
		y1="-105.168"
		x2="428.1649"
		y2="322.2892"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path
		in:fade={{ delay: 1000, duration: 1000 }}
		class="st1"
		d="M408,195c12.7,7.4,21.9,7.6,27.6,0.6c5.7-6.9,8.5-18.6,8.5-35.1V71.6c0-16.9,1.6-30.9,4.7-42
	c3.1-11.5,8.2-19.8,15.3-24.7c7.4-4.8,17-6.1,28.9-3.9c12.2,2.3,27.2,8.6,45,18.9l8.5,4.9v70l-10.6-6.1c-12.7-7.4-21.4-8.4-25.9-3.2
	c-4.2,5.4-6.4,16.3-6.4,32.8v78.3c0,20.4-2,36.5-6,48.4c-4,11.8-11.9,19.4-23.8,22.8c11.9,17.1,19.8,33.8,23.8,50.2
	c4,16.4,5.9,34.8,5.9,55.2v78.3c0,16.5,2.1,29.9,6.4,40.2c4.5,10.5,13.2,19.4,25.9,26.7l10.6,6.1v70l-8.5-4.9
	c-17.8-10.3-32.8-21.3-45-33c-11.9-11.6-21.5-24-28.9-37.3c-7.1-13.1-12.2-27.2-15.3-42.4c-3.1-14.7-4.7-30.6-4.7-47.4v-88.9
	c0-16.5-2.8-31.5-8.5-44.9c-5.7-13.5-14.9-23.9-27.6-31.2L408,195z" />
	<linearGradient
		id="SVGID_3_"
		gradientUnits="userSpaceOnUse"
		x1="753.3884"
		y1="-4.8961"
		x2="506.7093"
		y2="422.636"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path
		in:fly={{ x: 300, duration: 2000 }}
		class="st2"
		d="M690.5,482.5c-12.7-7.4-21.9-7.6-27.6-0.6c-5.7,6.9-8.5,18.6-8.5,35.1v88.9c0,16.9-1.6,30.9-4.7,42
	c-3.1,11.5-8.4,19.7-15.7,24.5c-7.1,4.9-16.7,6.2-28.9,3.9c-11.9-2.2-26.8-8.4-44.6-18.7l-8.5-4.9v-70l10.6,6.1
	c12.7,7.4,21.2,8.3,25.5,2.9c4.5-5.2,6.8-16.1,6.8-32.6v-78.3c0-20.4,2-36.5,6-48.4s11.9-19.4,23.8-22.8
	c-11.9-17.1-19.8-33.8-23.8-50.2c-4-16.4-5.9-34.8-5.9-55.2v-78.3c0-16.5-2.3-29.9-6.8-40.4c-4.2-10.3-12.7-19.1-25.5-26.5
	l-10.6-6.1v-70l8.5,4.9c17.8,10.3,32.7,21.2,44.6,32.8c12.2,11.7,21.8,24.2,28.9,37.3c7.4,13.3,12.6,27.5,15.7,42.6
	c3.1,14.7,4.7,30.6,4.7,47.4v88.9c0,16.5,2.8,31.5,8.5,44.9c5.7,13.5,14.9,23.9,27.6,31.2L690.5,482.5z" />
	<linearGradient
		id="SVGID_4_"
		gradientUnits="userSpaceOnUse"
		x1="634.8007"
		y1="-75.168"
		x2="388.1649"
		y2="352.2892"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path
		in:fly={{ x: 150, duration: 2000 }}
		class="st3"
		d="M368,225c12.7,7.4,21.9,7.6,27.6,0.6c5.7-6.9,8.5-18.6,8.5-35.1v-88.9c0-16.9,1.6-30.9,4.7-42
	c3.1-11.5,8.2-19.8,15.3-24.7c7.4-4.8,17-6.1,28.9-3.9c12.2,2.3,27.2,8.6,45,18.9l8.5,4.9v70l-10.6-6.1c-12.7-7.4-21.4-8.4-25.9-3.2
	c-4.2,5.4-6.4,16.3-6.4,32.8v78.3c0,20.4-2,36.5-6,48.4c-4,11.8-11.9,19.4-23.8,22.8c11.9,17.1,19.8,33.8,23.8,50.2
	c4,16.4,5.9,34.8,5.9,55.2v78.3c0,16.5,2.1,29.9,6.4,40.2c4.5,10.5,13.2,19.4,25.9,26.7l10.6,6.1v70l-8.5-4.9
	c-17.8-10.3-32.8-21.3-45-33c-11.9-11.6-21.5-24-28.9-37.3c-7.1-13.1-12.2-27.2-15.3-42.4c-3.1-14.7-4.7-30.6-4.7-47.4v-88.9
	c0-16.5-2.8-31.5-8.5-44.9c-5.7-13.5-14.9-23.9-27.6-31.2L368,225z" />
	<linearGradient
		id="SVGID_5_"
		gradientUnits="userSpaceOnUse"
		x1="320.0292"
		y1="4.6494"
		x2="156.7609"
		y2="287.5127"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path class="st4" d="M146,12.2l170.9,98.7l-0.1,409.3l-170.9-98.7L146,12.2z" />
	<path
		in:fly={{ x: -100, y: -100, duration: 2000 }}
		class="st5"
		d="M113.9,75.1l135.9,78.5v37.7l-135.9-78.5L113.9,75.1z" />
	<path in:fade class="st6" d="M167,167.8l130.8,75.5v13.6L167,181.5V167.8z" />
	<path in:fade={{ delay: 300 }} class="st6" d="M167,194.4l113.1,65.3v13.6L167,208V194.4z" />
	<path in:fade={{ delay: 600 }} class="st6" d="M167.1,238.7l130.6,75.4v58.6l-130.6-75.4V238.7z" />
	<linearGradient
		id="SVGID_6_"
		gradientUnits="userSpaceOnUse"
		x1="204.6561"
		y1="-94.9712"
		x2="256.6691"
		y2="52.5062"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path class="st7" d="M146,12.2l170.9,98.7v54.9L146,67.1V12.2z" />
	<path
		class="st8"
		d="M188.7,64.6c0,8.3-4.9,12.2-10.9,8.8c-6-3.5-10.8-13-10.8-21.3s4.9-12.2,10.9-8.8
	C183.8,46.8,188.7,56.3,188.7,64.6z" />
	<linearGradient
		id="SVGID_7_"
		gradientUnits="userSpaceOnUse"
		x1="530.0292"
		y1="384.1493"
		x2="366.7611"
		y2="667.0125"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path
		in:fade={{ duration: 1000 }}
		class="st9"
		d="M356,391.7l170.9,98.7l-0.1,409.3L355.9,801L356,391.7z" />
	<path
		in:fly={{ x: 100, y: 100, duration: 2000 }}
		class="st10"
		d="M421.1,510.8L557,589.2v37.6l-136-78.4L421.1,510.8z" />
	<path
		in:fade={{ delay: 500 }}
		class="st6"
		d="M377.1,549.7l130.7,75.5v58.5l-130.7-75.5L377.1,549.7z" />
	<path in:fade={{ delay: 1000 }} class="st6" d="M376.9,633.3l130.8,75.5v13.6L376.9,647V633.3z" />
	<path in:fade={{ delay: 1500 }} class="st6" d="M376.9,657.9L490,723.2v13.6l-113.1-65.3V657.9z" />
	<linearGradient
		id="SVGID_8_"
		gradientUnits="userSpaceOnUse"
		x1="414.6631"
		y1="284.5488"
		x2="466.6761"
		y2="432.0258"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path class="st11" d="M356,391.7l170.9,98.7v54.9L356,446.6L356,391.7z" />
	<path
		class="st8"
		d="M398.7,444.2c0,8.3-4.9,12.2-10.9,8.8c-6-3.5-10.8-13-10.8-21.3s4.9-12.2,10.9-8.8
	C393.8,426.3,398.7,435.9,398.7,444.2z" />
	<linearGradient
		id="SVGID_9_"
		gradientUnits="userSpaceOnUse"
		x1="261.5657"
		y1="278.3749"
		x2="107.9147"
		y2="398.6789"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path class="st12" d="M326.4,448.4L28.9,276.7L29,431.8l271.3,156.6l26.3,38.9L326.4,448.4z" />
	<path in:fade class="st6" d="M249.9,442l-65.2-37.6V418l65.2,37.6V442z" />
	<path
		in:fade={{ delay: 500 }}
		class="st6"
		d="M249.9,469.3L88.5,376.1v13.6L250,482.9L249.9,469.3z" />
	<path in:fade={{ delay: 1000 }} class="st6" d="M250,496.6L55.1,384.1v13.6L250,510.2V496.6z" />
	<path
		class="st10"
		d="M266,465.5c0,12.8,7.6,27.5,16.9,32.9s16.9-0.6,16.9-13.4s-7.6-27.5-16.9-32.9
	C273.5,446.7,266,452.7,266,465.5z" />
	<path
		class="st6"
		d="M58.3,167.8L18.9,145v-13.3l39.4,22.8c3.2,1.9,7.9,5.6,11.9,11.4c4.3,6.2,7.4,14,7.4,22.5
	c0,9.4-2.4,14.7-6.9,16.3c-4.3,1.4-9.3-1-12.4-2.8l-16.2-9.4l-0.1-0.1c-1.4-0.8-3.6-1.6-5.3-1.1c-1.4,0.4-3.1,1.9-3.1,7.1
	c0,5.2,1.6,8.4,3,10.3c1.7,2.4,3.9,4.1,5.3,4.8l0.2,0.1l49.6,28.6v13.3L42.4,227c-3.4-1.8-8.3-5.5-12.5-11.4
	c-4.6-6.5-7.8-14.7-7.8-23.9c0-9.1,3.2-13.8,7.7-15.1c4.2-1.2,9.1,0.6,12.5,2.6l16.1,9.3c2.3,1.3,4.1,1.9,5.2,1.5
	c0.9-0.3,2.5-1.6,2.5-8.3c0-4.4-1.4-7.2-2.8-9.2C61.7,170.3,59.6,168.5,58.3,167.8z" />
	<path
		class="st13"
		d="M30.6,146.4c0,11.4-6.7,16.7-14.9,12S0.8,140.6,0.8,129.2s6.7-16.7,14.9-12C23.9,122,30.6,135.1,30.6,146.4z" />
	<path
		class="st13"
		d="M109.6,256.4c0,11.4-6.7,16.7-14.9,12s-14.9-17.8-14.9-29.2s6.7-16.7,14.9-12
	C102.9,232,109.6,245.1,109.6,256.4z" />
	<linearGradient
		id="SVGID_10_"
		gradientUnits="userSpaceOnUse"
		x1="236.8253"
		y1="535.1464"
		x2="184.4533"
		y2="576.4514"
		gradientTransform="matrix(1 0 0 1 0 108)">
		<stop offset="0" style="stop-color:#FFFFFF" />
		<stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
	</linearGradient>
	<path
		class="st14"
		d="M215.9,604.1c6,3.5,10.8,11.8,10.8,18.8v30.5l20.2,11.6c6,3.5,10.8,11.8,10.8,18.8c0,6.9-4.9,9.7-10.8,6.3
	l-20.2-11.6V709c0,6.9-4.9,9.7-10.8,6.3c-6-3.5-10.8-11.8-10.8-18.8V666l-20.2-11.6c-6-3.5-10.8-11.8-10.8-18.8
	c0-6.9,4.9-9.7,10.8-6.3l20.2,11.6v-30.5C205.1,603.4,209.9,600.6,215.9,604.1z" />
</svg>
